<div #invoiceGrid>
	<lb-data-grid [data]="invoices()" [isLoading]="loading()" [gridConfig]="gridConfig()"></lb-data-grid>
</div>

@if (invoiceCount() >= pageLengthOptions[0]) {
	<div class="pagination-row">
		<lb-paginator
			[currentPage]="currentPage()"
			[itemsPerPage]="itemsPerPage()"
			[totalItems]="invoiceCount()"
			[itemsPerPageOptions]="pageLengthOptions"
			[scrollTargetElement]="invoiceGrid"
			(pageChange)="onPageChange($event)"
			(pageLengthChange)="onPageSizeChange($event)"
		>
		</lb-paginator>
	</div>
}
